import script from "./CarrosselDesktop.vue?vue&type=script&setup=true&lang=js"
export * from "./CarrosselDesktop.vue?vue&type=script&setup=true&lang=js"

import "./CarrosselDesktop.vue?vue&type=style&index=0&id=4a50fba3&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4a50fba3"]])

export default __exports__